import React, { useCallback } from 'react';
import Modal from '@cp/src/components/Modal/Modal';
import ConfirmationStep from './ConfirmationStep';
import ValidationStep from '../ValidationStep';

enum ModalStep {
  VALIDATION = 1,
  CONFIRMATION = 2
}

interface InitiateMockModalProps {
  mockModalState: {
    isVisible: boolean;
    currentStep: number;
  };
  setMockModalState: (
    value: React.SetStateAction<{
      isVisible: boolean;
      currentStep: number;
    }>
  ) => void;
}

const InitiateMockModal: React.FC<InitiateMockModalProps> = ({
  mockModalState,
  setMockModalState
}) => {
  const { isVisible, currentStep } = mockModalState;
  const isValidationStep = currentStep === ModalStep.VALIDATION;

  const handleCloseModal = useCallback(() => {
    setMockModalState(prev => ({
      ...prev,
      isVisible: false
    }));
  }, []);

  const handleNextStep = useCallback(() => {
    setMockModalState(prev => ({
      ...prev,
      currentStep: ModalStep.CONFIRMATION
    }));
  }, []);

  return (
    <Modal
      visible={isVisible}
      onClose={handleCloseModal}
      showCloseIcon={false}
      header={
        isValidationStep ? 'Validate current inputs before you proceed' : 'Initiate mock allocation'
      }
      headerClassName="!px-6 !pt-6"
      contentClassName="min-w-[460px]"
      closeOnOutsideClick
    >
      {isValidationStep ? (
        <ValidationStep handleCloseModal={handleCloseModal} handleNextStep={handleNextStep} />
      ) : (
        <ConfirmationStep handleCloseModal={handleCloseModal} />
      )}
    </Modal>
  );
};

export default InitiateMockModal;
